import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=bf71163e&scoped=true&"
import script from "./LoginPopup.vue?vue&type=script&lang=js&"
export * from "./LoginPopup.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopup.vue?vue&type=style&index=0&id=bf71163e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf71163e",
  null
  
)

export default component.exports